/*
  Kiwi Ears · audio glossary (Rene 2026-08-30) — sections/gl-*.

  IT FILTERS MARKUP, IT NEVER BUILDS A DEFINITION. All 134 terms are rendered
  into the page by snippets/gl-directory.liquid, because a glossary earns its
  traffic by being indexable and because the page then works with no JS at all
  — the controls simply do nothing and the A–Z directory reads straight down.
  Everything below reads that markup: the search index, the topic chips, the
  letter bar, the counts and the drawer content all come from the cards, so
  none of them can advertise something the directory does not contain.

  SEARCH RANKING is the prototype's, preserved from AGENT_HANDOFF.md:
    exact term > term prefix > term contains > definition/category contains.
  Rank matters more than it looks: typing "bass" should surface Bass before
  Sub-bass before every definition that merely mentions bass.

  Saved terms use the package's localStorage keys (kiwiGlossarySaved,
  kiwiGlossaryMode) so a reader who used the prototype keeps their list.

  Deep links: #term=<slug> opens that term on load and every open updates the
  hash, so a definition can be pasted to somebody — the house state-in-the-URL
  rule, and the reason a glossary link is worth sending.
*/
(function () {
  'use strict';
  if (window.__kiwiGlossary) return;
  window.__kiwiGlossary = true;

  var root = document.querySelector('[data-gl-root]');
  if (!root) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var SAVED_KEY = 'kiwiGlossarySaved';
  var MODE_KEY = 'kiwiGlossaryMode';

  /* ------------------------------------------------------------- the data
     Read once out of the DOM the server already rendered. */
  var CARDS = $$('[data-gl-term]', root).map(function (n) {
    var d = function (k) { var el = $('[data-gl-' + k + ']', n); return el ? el.textContent.trim() : ''; };
    return {
      node: n,
      slug: n.getAttribute('data-slug'),
      term: n.getAttribute('data-term'),
      lower: (n.getAttribute('data-term') || '').toLowerCase(),
      cat: n.getAttribute('data-cat'),
      catName: (($('.gl-cat', n) || {}).textContent || '').trim(),
      letter: n.getAttribute('data-letter'),
      simple: (($('.gl-simple', n) || {}).textContent || '').trim(),
      technical: d('technical'),
      why: d('why'),
      myth: d('myth'),
      related: d('related') ? d('related').split(',') : [],
      group: n.closest('.gl-group')
    };
  });
  if (!CARDS.length) return;
  var BY = {};
  CARDS.forEach(function (c) { BY[c.slug] = c; });

  var META = {};
  try { META = JSON.parse(($('[data-gl-meta]', root) || {}).textContent || '{}'); } catch (e) {}

  var GROUPS = $$('.gl-group', root);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- state */
  var state = { q: '', cat: '', letter: '', savedOnly: false, depth: 'quick' };
  var saved = [];
  try { saved = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]') || []; } catch (e) { saved = []; }
  try { var m = localStorage.getItem(MODE_KEY); if (m === 'deep' || m === 'quick') state.depth = m; } catch (e) {}
  function persistSaved() { try { localStorage.setItem(SAVED_KEY, JSON.stringify(saved)); } catch (e) {} }

  /* ------------------------------------------------------------- controls
     Chips and letters are derived from the cards, not typed anywhere. */
  var chipWrap = $('[data-gl-chips]', root);
  var alphaWrap = $('[data-gl-alpha]', root);

  function chip(label, count, value, attr) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gl-chip';
    b.setAttribute(attr, value);
    b.setAttribute('aria-pressed', 'false');
    b.appendChild(document.createTextNode(label));
    if (count != null) {
      var s = document.createElement('span');
      s.className = 'gl-chipcount';
      s.textContent = count;
      b.appendChild(s);
    }
    return b;
  }

  if (chipWrap) {
    var counts = {};
    CARDS.forEach(function (c) { counts[c.cat] = (counts[c.cat] || 0) + 1; });
    var all = chip('All topics', CARDS.length, '', 'data-gl-cat');
    all.setAttribute('aria-pressed', 'true');
    chipWrap.appendChild(all);
    Object.keys(META.topics || {}).forEach(function (slug) {
      if (!counts[slug]) return;   /* a topic with nothing behind it is not offered */
      chipWrap.appendChild(chip(META.topics[slug], counts[slug], slug, 'data-gl-cat'));
    });
  }
  if (alphaWrap) {
    var present = {};
    CARDS.forEach(function (c) { present[c.letter] = true; });
    var allL = chip('All', null, '', 'data-gl-letter');
    allL.className = 'gl-letter';
    allL.setAttribute('aria-pressed', 'true');
    alphaWrap.appendChild(allL);
    '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (L) {
      var b = chip(L === '#' ? '0–9' : L, null, L, 'data-gl-letter');
      b.className = 'gl-letter';
      /* a letter with no terms is disabled, not removed — a bar that
         reshuffles under the cursor is worse than a greyed key */
      if (!present[L]) b.disabled = true;
      alphaWrap.appendChild(b);
    });
  }

  /* --------------------------------------------------------------- search */
  function rank(c, q) {
    if (c.lower === q) return 0;
    if (c.lower.indexOf(q) === 0) return 1;
    if (c.lower.indexOf(q) > -1) return 2;
    if (c.simple.toLowerCase().indexOf(q) > -1) return 3;
    if (c.catName.toLowerCase().indexOf(q) > -1) return 4;
    if ((c.technical + ' ' + c.why).toLowerCase().indexOf(q) > -1) return 5;
    return -1;
  }

  var countEl = $('[data-gl-count]', root);
  var emptyEl = $('[data-gl-empty]', root);
  var clearEl = $('[data-gl-clear]', root);
  var savedCountEl = $('[data-gl-savedcount]', root);

  function apply() {
    var q = state.q.trim().toLowerCase();
    var shown = 0;
    var ranked = [];

    CARDS.forEach(function (c) {
      var ok = true;
      if (state.cat && c.cat !== state.cat) ok = false;
      if (ok && state.letter && c.letter !== state.letter) ok = false;
      if (ok && state.savedOnly && saved.indexOf(c.slug) === -1) ok = false;
      var r = -1;
      if (ok && q) {
        r = rank(c, q);
        if (r === -1) ok = false;
      }
      c.node.hidden = !ok;
      if (ok) { shown++; if (q) ranked.push({ c: c, r: r }); }
    });

    /* With a query the answer is a ranked list, so the A–Z grouping stops
       meaning anything: collapse to one group ordered by rank. */
    if (q && ranked.length) {
      ranked.sort(function (a, b) { return a.r - b.r || a.c.lower.localeCompare(b.c.lower); });
      var host = GROUPS[0] ? $('.gl-grid', GROUPS[0]) : null;
      if (host) ranked.forEach(function (x) { host.appendChild(x.c.node); });
    } else if (!q) {
      /* put every card back under its own letter */
      CARDS.forEach(function (c) {
        var home = $('.gl-grid', c.group);
        if (home && c.node.parentElement !== home) home.appendChild(c.node);
      });
    }

    GROUPS.forEach(function (g, i) {
      if (q) { g.hidden = i !== 0; return; }
      g.hidden = !$$('[data-gl-term]', g).some(function (n) { return !n.hidden; });
    });
    if (GROUPS[0]) GROUPS[0].classList.toggle('is-ranked', !!q);

    if (countEl) countEl.textContent = shown + (shown === 1 ? ' term' : ' terms');
    if (emptyEl) emptyEl.hidden = shown > 0;
    if (clearEl) clearEl.hidden = !(state.q || state.cat || state.letter || state.savedOnly);
    if (savedCountEl) savedCountEl.textContent = saved.length;

    $$('[data-gl-cat]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-gl-cat') === state.cat)); });
    $$('[data-gl-letter]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-gl-letter') === state.letter)); });
    $$('[data-gl-save]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(saved.indexOf(b.getAttribute('data-gl-save')) > -1)); });
    root.setAttribute('data-gl-depth', state.depth);
  }

  /* --------------------------------------------------------------- drawer */
  var dlg = $('[data-gl-drawer]', root);
  var path = { id: null, i: 0 };

  function fill(sel, text, wrapSel) {
    var el = $(sel, dlg);
    if (el) el.textContent = text || '';
    if (wrapSel) { var w = $(wrapSel, dlg); if (w) w.hidden = !text; }
  }

  function openTerm(slug, viaPath) {
    var c = BY[slug];
    if (!c || !dlg) return;
    if (!viaPath) { path.id = null; }

    fill('[data-gl-d-cat]', c.catName);
    fill('[data-gl-d-term]', c.term);
    fill('[data-gl-d-simple]', c.simple);
    fill('[data-gl-d-technical]', c.technical, '[data-gl-d-techwrap]');
    fill('[data-gl-d-why]', c.why, '[data-gl-d-whywrap]');
    fill('[data-gl-d-myth]', c.myth, '[data-gl-d-mythwrap]');

    var rel = $('[data-gl-d-related]', dlg);
    var relWrap = $('[data-gl-d-relwrap]', dlg);
    if (rel) {
      rel.textContent = '';
      c.related.forEach(function (r) {
        var t = BY[r];
        if (!t) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gl-relchip';
        b.setAttribute('data-gl-open', r);
        b.textContent = t.term;
        rel.appendChild(b);
      });
      if (relWrap) relWrap.hidden = !rel.children.length;
    }

    var sv = $('[data-gl-d-save]', dlg);
    if (sv) {
      var on = saved.indexOf(slug) > -1;
      sv.setAttribute('aria-pressed', String(on));
      sv.setAttribute('data-gl-save-target', slug);
      var lbl = $('[data-gl-d-savelabel]', sv);
      if (lbl) lbl.textContent = on ? 'Saved' : 'Save';
    }

    paintPathBar();
    if (!dlg.open) {
      dlg.showModal();
      if (window.lenis && window.lenis.stop) window.lenis.stop();
      document.documentElement.style.overflow = 'hidden';
    }
    try { history.replaceState({}, '', '#term=' + slug); } catch (e) {}
  }

  function paintPathBar() {
    var bar = $('[data-gl-pathbar]', dlg);
    if (!bar) return;
    var p = path.id && META.paths ? META.paths[path.id] : null;
    bar.hidden = !p;
    if (!p) return;
    var lbl = $('[data-gl-pathlabel]', bar);
    var pos = $('[data-gl-pathpos]', bar);
    if (lbl) lbl.textContent = p.title;
    if (pos) pos.textContent = (path.i + 1) + ' / ' + p.terms.length;
    var prev = $('[data-gl-path-prev]', bar), next = $('[data-gl-path-next]', bar);
    if (prev) prev.disabled = path.i === 0;
    if (next) next.disabled = path.i >= p.terms.length - 1;
  }

  function step(delta) {
    var p = path.id && META.paths ? META.paths[path.id] : null;
    if (!p) return;
    var i = path.i + delta;
    if (i < 0 || i >= p.terms.length) return;
    path.i = i;
    openTerm(p.terms[i], true);
  }

  if (dlg) {
    /* dialog.close() fires 'close' for the button, Esc AND the backdrop, so
       one listener restores everything */
    dlg.addEventListener('close', function () {
      if (window.lenis && window.lenis.start) window.lenis.start();
      document.documentElement.style.overflow = '';
      try { history.replaceState({}, '', window.location.pathname + window.location.search); } catch (e) {}
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();   /* backdrop */
    });
  }

  /* -------------------------------------------------------------- wiring */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var open = t.closest('[data-gl-open]');
    if (open) { e.preventDefault(); openTerm(open.getAttribute('data-gl-open')); return; }

    var card = t.closest('.gl-card');
    if (card && !t.closest('[data-gl-save]')) {
      /* the whole card is the target; the heading button keeps the semantics */
      e.preventDefault(); openTerm(card.getAttribute('data-slug')); return;
    }

    var sv = t.closest('[data-gl-save]') || t.closest('[data-gl-d-save]');
    if (sv) {
      var slug = sv.getAttribute('data-gl-save') || sv.getAttribute('data-gl-save-target');
      if (!slug) return;
      var i = saved.indexOf(slug);
      if (i > -1) saved.splice(i, 1); else saved.push(slug);
      persistSaved();
      var dl = $('[data-gl-d-savelabel]', dlg);
      if (dl && ($('[data-gl-d-save]', dlg) || {}).getAttribute('data-gl-save-target') === slug) {
        dl.textContent = saved.indexOf(slug) > -1 ? 'Saved' : 'Save';
        $('[data-gl-d-save]', dlg).setAttribute('aria-pressed', String(saved.indexOf(slug) > -1));
      }
      apply();
      return;
    }

    var c = t.closest('[data-gl-cat]');
    if (c) { state.cat = c.getAttribute('data-gl-cat'); apply(); return; }

    var L = t.closest('[data-gl-letter]');
    if (L && !L.disabled) { state.letter = L.getAttribute('data-gl-letter'); state.q = ''; syncInputs(); apply(); return; }

    if (t.closest('[data-gl-topic]')) {
      state.cat = t.closest('[data-gl-topic]').getAttribute('data-gl-topic');
      state.q = ''; state.letter = ''; syncInputs(); apply(); goResults();
      return;
    }
    if (t.closest('[data-gl-savedonly]')) {
      state.savedOnly = !state.savedOnly;
      t.closest('[data-gl-savedonly]').setAttribute('aria-pressed', String(state.savedOnly));
      apply(); return;
    }
    if (t.closest('[data-gl-clear]')) {
      state = { q: '', cat: '', letter: '', savedOnly: false, depth: state.depth };
      var so = $('[data-gl-savedonly]', root); if (so) so.setAttribute('aria-pressed', 'false');
      syncInputs(); apply(); return;
    }
    if (t.closest('[data-gl-random]')) {
      openTerm(CARDS[Math.floor(Math.random() * CARDS.length)].slug); return;
    }
    var sp = t.closest('[data-gl-start-path]');
    if (sp) {
      var id = sp.getAttribute('data-gl-start-path');
      var p = META.paths ? META.paths[id] : null;
      if (!p || !p.terms.length) return;
      path.id = id; path.i = 0;
      openTerm(p.terms[0], true);
      return;
    }
    if (t.closest('[data-gl-path-prev]')) { step(-1); return; }
    if (t.closest('[data-gl-path-next]')) { step(1); return; }
    if (t.closest('[data-gl-path-exit]')) { path.id = null; paintPathBar(); return; }
    if (t.closest('[data-gl-d-close]')) { dlg.close(); return; }
    if (t.closest('[data-gl-reroll]')) { paintWotd(true); return; }
    if (t.closest('[data-gl-wotd-open]')) {
      var w = $('[data-gl-wotd]', document);
      if (w && w.getAttribute('data-slug')) openTerm(w.getAttribute('data-slug'));
      return;
    }
    var dp = t.closest('[data-gl-depth]');
    if (dp) {
      state.depth = dp.getAttribute('data-gl-depth');
      try { localStorage.setItem(MODE_KEY, state.depth); } catch (e) {}
      $$('[data-gl-depth]', root).forEach(function (b) {
        var on = b === dp;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      apply();
      return;
    }
  });

  function goResults() {
    var el = $('.gl-results', root);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 90;
    if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(y, { immediate: reduce });
    else window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  var mainInput = $('[data-gl-search]', root);
  var heroInput = $('[data-gl-herosearch]', document);
  function syncInputs() {
    if (mainInput && mainInput.value !== state.q) mainInput.value = state.q;
    if (heroInput && heroInput.value !== state.q) heroInput.value = state.q;
  }
  function onType(v, fromHero) {
    state.q = v;
    state.letter = '';
    syncInputs();
    apply();
    if (fromHero && v) goResults();
  }
  if (mainInput) mainInput.addEventListener('input', function () { onType(mainInput.value, false); });
  if (heroInput) heroInput.addEventListener('input', function () { onType(heroInput.value, true); });
  $$('form[data-gl-form], form[data-gl-heroform]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); goResults(); });
  });

  /* "/" focuses search unless focus is already in a field — the package's
     shortcut, kept. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable)) return;
    e.preventDefault();
    (heroInput || mainInput || {}).focus && (heroInput || mainInput).focus();
  });

  /* ---------------------------------------------------------- word of day */
  function paintWotd(random) {
    var w = $('[data-gl-wotd]', document);
    if (!w) return;
    var i;
    if (random) i = Math.floor(Math.random() * CARDS.length);
    else {
      /* stable per day so everyone sees the same term */
      var d = new Date();
      var key = d.getFullYear() * 1000 + (d.getMonth() + 1) * 40 + d.getDate();
      i = key % CARDS.length;
    }
    var c = CARDS[i];
    w.setAttribute('data-slug', c.slug);
    var set = function (sel, v) { var el = $(sel, w); if (el) el.textContent = v; };
    set('[data-gl-wotd-cat]', c.catName);
    set('[data-gl-wotd-term]', c.term);
    set('[data-gl-wotd-def]', c.simple);
  }

  /* -------------------------------------------------------------- stats */
  (function stats() {
    var cats = {};
    CARDS.forEach(function (c) { cats[c.cat] = true; });
    var map = { total: CARDS.length, topics: Object.keys(cats).length, depths: 2 };
    $$('[data-gl-stat]').forEach(function (el) {
      var v = map[el.getAttribute('data-gl-stat')];
      if (v != null) el.textContent = v;
    });
  })();

  /* --------------------------------------------------------------- boot */
  paintWotd(false);
  apply();
  (function deepLink() {
    var m = /#term=([a-z0-9-]+)/i.exec(window.location.hash || '');
    if (m && BY[m[1]]) openTerm(m[1]);
  })();
})();
